import { h, Component } from 'preact';

interface PreactTesterState {
  dateFrom?: string;
  dateTo?: string;
}

const TEST_INQUIRY_CODE = 'IQ29180'; // RENT
// const TEST_INQUIRY_CODE = 'IQ28938'; // SALE

export class PreactTester extends Component<any, PreactTesterState> {
  render(props, state: PreactTesterState) {
    return (
      <div className="container-fluid px-0">
        <div className="offset-lg-3 col-md-6 mt-4">
          {/* <AddClientModalHost
            onClose={ () => console.log('onClose!') }
            onProceed={ () => console.log('onProceed!') } /> */}
        </div>
      </div>
    );
  }
}